import React, { useEffect } from "react";
import PropTypes from "prop-types";

const WebViewField = ({ field: { name, text } }) => {
  const fieldId = `web-view-field-${String(name).replace("_", "")}`;
  const minFieldHeight = 200;
  const errorMessageHeight = 60;

  useEffect(() => {
    // Get the frame and set it to consume free space to fill the page without scrolling unless it
    // would be less than the minimum height in which case we set it to the minimum height.
    const webViewField = document.getElementById(fieldId);

    const fieldHeight =
      window.innerHeight -
      document.documentElement.offsetHeight -
      errorMessageHeight;
    webViewField.height =
      fieldHeight < minFieldHeight ? minFieldHeight : fieldHeight;
    webViewField.hidden = false;
  }, []);

  return (
    <iframe
      id={fieldId}
      src={text}
      width='100%'
      hidden='true'
      title={fieldId}
    />
  );
};

WebViewField.propTypes = {
  field: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.any])).isRequired
};

export default WebViewField;
